import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { IconLabelComponent } from '../../common/icon-label/icon-label.component';

@Component({
    selector: 'account-back',
    templateUrl: './account-back.html',
    standalone: true,
    imports: [IconLabelComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountBackComponent extends UiComponent {
    /**
     * If asynchronous change detection is allowed
     */
    protected acyncCd = false;

    @Input()
    link = '/account';
}
